import { h } from 'preact';
import Footer from '../Footer'

import style from "./style.css";

import cx from 'classnames';

const MAILCHIMP_URL = 'https://playerindex.us19.list-manage.com/subscribe/post?u=f951b8ae6c0dbe41883af2a10&amp;id=73368ea504'
const ContactUs = () => (
    <div className={cx(style.contactUs, 'flex', 'flex-1', 'flex-col', 'content-center', 'justify-center')}>
        <div className={cx(style.inputSection, 'flex', 'flex-col', 'content-center', 'justify-center', 'self-center')}>
            <div className={cx(style.label, 'flex', 'flex-row', 'justify-center', 'self-center', 'content-center')}>
                ENQUIRIES
            </div>
            <form action={MAILCHIMP_URL} method="post" id="mc-embedded-subscribe-form" name="mc-embedded-subscribe-form" class="validate" target="_blank" novalidate>

                <div className={cx(style.inputColumn, 'flex', 'flex-row', 'content-center', 'justify-between')}>
                    <input type="text" name="NAME" placeholder="Your Name" />
                    <input type="text" name="EMAIL" placeholder="Your email" />
                </div>
                <div className={cx(style.inputColumn, 'flex', 'flex-row', 'content-center', 'justify-between')}>
                    <textarea name="SUBJECT" placeholder="Subject" className={cx('flex', 'flex-1')} />
                </div>
                <div>all fields required</div>
                <div className={cx(style.submit, 'flex', 'flex-row', 'content-center', 'justify-center')}>
                    <input className={cx('flex', 'justify-center', 'self-center', 'content-center')} type="submit" value="SEND" />
                </div>
            </form>
        </div>
        <Footer/>
    </div>
);

export default ContactUs;




// WEBPACK FOOTER //
// ./components/ContactUs/index.jsx